import '@syncfusion/ej2-react-inplace-editor/styles/inplace-editor/material.css';
import { formatISODateTime } from 'common/widgets';
import 'components/ProviderData/IpaAdministration/organisms/IpaAdministration.css';
import styles from 'components/ProviderData/IpaAdministration/organisms/IpaAdministrationDetailView/IpaAdministrationDetailViewLeftHandCard.module.css';

type IpaAdministrationDetailViewLeftHandCardProps = {
    ipa: Record<string, any>;
    mso: Record<string, any>;
};
function IpaAdministrationDetailViewLeftHandCard(props: IpaAdministrationDetailViewLeftHandCardProps) {
    return (
        <>
            {props?.ipa?.id && (
                <div>
                    <div className='ipa-card-content'>
                        <section className='responsiveImgContainer'>
                            <img
                                src='/images/team.svg'
                                alt='image team'
                                className={styles['left-hand-card-image']}
                            />
                        </section>
                        <hr className='hideHR' />
                        <section className='detailsWrap'>
                            <div className='labelInputWrap'>
                                <label className='customLabel'>
                                    <b className='boldElementStyle'>IPA Name</b>
                                    <b>:</b>
                                </label>
                                <span className='customInputField paddingRight'>{props?.ipa?.ipaDesc}</span>
                            </div>
                            <div className='labelInputWrap'>
                                <label className='customLabel'>
                                    <b className='boldElementStyle'>IPA Code</b>
                                    <b>:</b>
                                </label>
                                <span className='customInputField paddingRight'>{props?.ipa?.ipaCode}</span>
                            </div>
                            <div className='labelInputWrap'>
                                <label className='customLabel'>
                                    <b className='boldElementStyle'>Facets Code</b>
                                    <b>:</b>
                                </label>
                                <span className='customInputField paddingRight'>{props?.ipa?.facetsCode}</span>
                            </div>
                            <div className='labelInputWrap'>
                                <label className='customLabel'>
                                    <b className='boldElementStyle'>Contract Name</b>
                                    <b>:</b>
                                </label>
                                <span className='customInputField paddingRight'>{props?.ipa?.contractName}</span>
                            </div>
                            <div className='labelInputWrap'>
                                <label className='customLabel'>
                                    <b className='boldElementStyle'>Vendor Name</b>
                                    <b>:</b>
                                </label>
                                <span className='customInputField paddingRight'>{props?.ipa?.vendorNm}</span>
                            </div>
                            <div className='labelInputWrap'>
                                <label className='customLabel'>
                                    <b className='boldElementStyle'>MSO Name</b>
                                    <b>:</b>
                                </label>
                                <span className='customInputField paddingRight'>{props?.mso?.name}</span>
                            </div>
                            <div className='labelInputWrap'>
                                <label className='customLabel'>
                                    <b className='boldElementStyle'>MSO Address</b>
                                    <b>:</b>
                                </label>
                                <span className='customInputField paddingRight'>{props?.mso?.address1}</span>
                            </div>
                            <div className='labelInputWrap'>
                                <label className='customLabel'>
                                    <b className='boldElementStyle'>MSO Email</b>
                                    <b>:</b>
                                </label>
                                <span className='customInputField paddingRight'>{props?.mso?.email}</span>
                            </div>
                            <br />
                            <div className='labelInputWrap'>
                                <label className='customLabel'>
                                    <b className='boldElementStyle'>Created By</b>
                                    <b>:</b>
                                </label>
                                <span className='customInputField paddingRight'>{props?.ipa?.createdBy}</span>
                            </div>
                            <div className='labelInputWrap'>
                                <label className='customLabel'>
                                    <b className='boldElementStyle'>Created Date</b>
                                    <b>:</b>
                                </label>
                                <span className='customInputField paddingRight'>
                                    {formatISODateTime(props?.ipa?.createdDt)}
                                </span>
                            </div>
                            <br />
                            <div className='labelInputWrap'>
                                <label className='customLabel'>
                                    <b className='boldElementStyle'>Updated By</b>
                                    <b>:</b>
                                </label>
                                <span className='customInputField paddingRight'>{props?.ipa?.updatedBy}</span>
                            </div>
                            <div className='labelInputWrap'>
                                <label className='customLabel'>
                                    <b className='boldElementStyle'>Updated Date</b>
                                    <b>:</b>
                                </label>
                                <span className='customInputField paddingRight'>
                                    {formatISODateTime(props?.ipa?.updatedDt)}
                                </span>
                            </div>
                        </section>
                    </div>
                </div>
            )}
        </>
    );
}

export default IpaAdministrationDetailViewLeftHandCard;
